module.exports = __webpack_public_path__ + "static/img/p7.ea44253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/p7.jpg
// module id = 9pnz
// module chunks = 0